import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'

interface IProps {
  reviewMapping: Record<string, number>
  reviewCount: number
  selectedRating: string
}

const RATINGS = [5, 4, 3, 2, 1]
const LABELS = {
  5: 'Excellent',
  4: 'Very Good',
  3: 'Average',
  2: 'Poor',
  1: 'Terrible',
}

// ReviewRatingFilter : 星の数ごとの件数を棒グラフで示し、クリックで ?rating= に絞り込む.
const ReviewRatingFilter: React.FC<IProps> = ({ reviewMapping, reviewCount, selectedRating }) => (
  <Wrapper>
    {RATINGS.map(rating => {
      const count = reviewMapping[rating] ?? 0
      const isActive = rating.toString() === selectedRating

      return (
        <div key={rating} className={`Rating${isActive ? ' active' : ''}`}>
          <a href={`?rating=${rating}`}>
            <p className="Label">{LABELS[rating]}</p>
            <p className="Count">{count}</p>
            <div className="Bar">
              <div
                className="Fill"
                style={{ width: `${(reviewCount ? count / reviewCount : 0) * 100}%` }}
              />
            </div>
          </a>
        </div>
      )
    })}
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;

  .Rating {
    min-width: 260px;
    margin: 4px 0;
    color: ${constants.COLORS.black};

    &.active {
      color: ${constants.COLORS.primary};
      font-weight: bold;
    }

    a {
      display: flex;
      color: inherit;
    }
    .Label {
      width: 82px;
      margin-right: 12px;
    }
    .Count {
      min-width: 32px;
      margin-left: 12px;
    }
    .Bar {
      width: 120px;
      border: ${constants.COLORS.divider} 1px solid;
      border-radius: 4px;
    }
    .Fill {
      height: 100%;
      border-radius: 4px;
      background-color: ${constants.COLORS.useally};
    }
  }
`

export default ReviewRatingFilter
